import React from 'react';

const Header = ({ onBrowseClick, onDemoClick }) => {
  return (
    <header>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <span>⚡</span>Layrs
          </div>
          <div className="header-nav">
            <button className="btn-header" onClick={onBrowseClick}>
              Browse Use Cases
            </button>
            <button className="btn-header" onClick={onDemoClick}>
              Book Demo
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
